import { get, set, flow, groupBy, keyBy, isEmpty } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  fetchPosTrackingMethodLocations,
  fetchPosLocationsForTrackingMethod,
  createPosLocationsForTrackingMethod,
  deletePosLocationsForTrackingMethod
} from '../../../sagas/routines';

const groupLocationsByTrackingMethod = flow(
  groupBy(get('trackingMethod.id')),
  keyBy(get('0.trackingMethod.id'))
);

const initialState = {
  locationsByTrackingMethod: null,
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null
};

export const fetchAllHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(
      'locationsByTrackingMethod',
      groupLocationsByTrackingMethod(response.items),
      state
    ),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const fetchOneHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    if (isEmpty(response)) return state;
    const trackingMethodId = get('0.trackingMethod.id', response);
    return {
      ...state,
      locationsByTrackingMethod: {
        ...(state.locationsByTrackingMethod || {}),
        [trackingMethodId]: response
      }
    };
  },
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const createHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const { items } = response;
    const trackingMethodId = get('0.trackingMethodId', items);
    return set(`locationsByTrackingMethod.${trackingMethodId}`, items, state);
  },
  [routine.FAILURE]: (state, { error }) => set('savingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

export const deleteHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, deleting: true, deleted: false }),
  [routine.FAILURE]: (state, { error }) => set('deletingError', error, state),
  [routine.FULFILL]: state => ({ ...state, deleting: false, deleted: true })
});

export default createReducer(initialState, {
  ...fetchAllHandler(fetchPosTrackingMethodLocations),
  ...fetchOneHandler(fetchPosLocationsForTrackingMethod),
  ...createHandler(createPosLocationsForTrackingMethod),
  ...deleteHandler(deletePosLocationsForTrackingMethod)
});
